import Modal from 'react-modal'
import { useEffect, useRef, useState } from 'react'
import AlbumArt from '../../components/AlbumArt/AlbumArt'
import TextInput from '../../components/TextInput/TextInput'
import { cloneDeep, set } from 'lodash'

const PlaylistGroupModal = ({ groupToEdit, onSubmit, onCancel }) => {
  const ref = useRef(null)
  const [values, setValues] = useState({
    text: '',
    data: {
      open: true,
    },
    ...groupToEdit,
  })
  const [errors, setErrors] = useState({})
  const isNew = !values.id

  function handleNameChange(evt) {
    setValues({ ...values, text: evt.target.value })
  }

  function handleOpenChange(evt) {
    const newValues = cloneDeep(values)
    set(newValues, 'data.open', evt.target.checked)
    setValues(newValues)
  }

  function handleArtChange(value) {
    const newValues = cloneDeep(values)
    set(newValues, 'data.art', value)
    setValues(newValues)
  }

  function handleDescriptionChange(evt) {
    const newValues = cloneDeep(values)
    set(newValues, 'data.description', evt.target.value)
    setValues(newValues)
  }

  function handleSubmit() {
    if (values.text) {
      onSubmit(values)
    } else {
      setErrors({
        name: true,
      })
    }
  }
  function handleAfterOpen() {
    if (isNew) {
      ref.current.querySelectorAll('input[name="name"]')?.[0]?.focus()
    }
  }

  return (
    <Modal
      isOpen={true}
      onRequestClose={onCancel}
      contentLabel="Edit Group Modal"
      className="modal w-[650px]"
      onAfterOpen={handleAfterOpen}
      overlayClassName="modal-overlay"
    >
      <div className="" ref={ref}>
        <h2 className="p-6 bg-gray-light rounded-t">
          {isNew ? 'Create Folder' : 'Edit Folder'}
        </h2>
        <div className="flex flex-row p-6">
          <AlbumArt
            label="Folder Art"
            value={values?.data?.art}
            onChange={handleArtChange}
            showRemove
          />
          <div className="flex flex-col pl-6 flex-fill">
            <div className="flex flex-col flex-fill">
              <TextInput
                label="Name *"
                value={values.text}
                name="name"
                onEnter={handleSubmit}
                onChange={handleNameChange}
              />
              {errors?.name && (
                <div className="mt-1 text-error">Please enter a name.</div>
              )}
              <div className="mt-4">
                <TextInput
                  label="Description"
                  name="description"
                  value={values?.data?.description}
                  onEnter={handleSubmit}
                  onChange={handleDescriptionChange}
                />
              </div>
              <div className="mt-4">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="open-by-default"
                    defaultChecked={values?.data?.open}
                    onChange={handleOpenChange}
                  />
                  <label
                    htmlFor="open-by-default"
                    className="ml-1 leading-[13px]"
                  >
                    Open by Default
                  </label>
                </div>
                <div className="text-xs text-white-dark mt-1.5">
                  Folder will be open by default when used in an embeded player.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-end p-6 bg-gray-dark">
          <button className="button" onClick={onCancel}>
            Cancel
          </button>
          <button className="button primary" onClick={handleSubmit}>
            {isNew ? 'Create' : 'Save'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default PlaylistGroupModal
